import { COOKIE_NAME, COOKIE_REGEX } from './shared-constants.js';

let inMemoryCookie;
const allowedDomains = ["vpsvc", "vistaprint"];
const domainForCookie = function() {
  if (typeof document === "undefined" || typeof document.cookie === "undefined" || !window.location.hostname) {
    return "";
  }
  const host = window.location.hostname;
  for (let i = 0; i < allowedDomains.length; i += 1) {
    const domainIndex = host.lastIndexOf(allowedDomains[i]);
    if (domainIndex >= 0) {
      return host.slice(domainIndex);
    }
  }
  return host;
};
const setCookieContext = function(context) {
  const now = /* @__PURE__ */ new Date();
  const expireDate = new Date(now.getTime() + 1e3 * 604800);
  const encodedContext = encodeContextObject(context);
  let cookieString = `${COOKIE_NAME}=${encodedContext};expires=${expireDate.toUTCString()};SameSite=Strict;path=/`;
  if (typeof document !== "undefined" && typeof document.cookie !== "undefined") {
    const domain = domainForCookie();
    cookieString += `;domain=${domain}`;
    document.cookie = cookieString;
  }
  inMemoryCookie = cookieString;
};
const resetCookieContext = function() {
  const now = /* @__PURE__ */ new Date();
  const expireDate = new Date(now.getTime() + 1e3 * 604800);
  const encodedContext = "";
  let cookieString = `${COOKIE_NAME}=${encodedContext};expires=${expireDate.toUTCString()};SameSite=Strict;path=/`;
  if (typeof document !== "undefined" && typeof document.cookie !== "undefined") {
    const domain = domainForCookie();
    cookieString += `;domain=${domain}`;
    document.cookie = cookieString;
  }
  inMemoryCookie = cookieString;
};
const getRawCookieValue = () => {
  const cookieString = typeof document !== "undefined" && typeof document.cookie !== "undefined" && document.cookie !== "" && document.cookie.match(COOKIE_REGEX) ? document.cookie : inMemoryCookie;
  try {
    const match = cookieString.match(COOKIE_REGEX);
    if (!match) {
      return null;
    }
    return match[2];
  } catch (ex) {
    return null;
  }
};
const encodeContextObject = function(contextObj) {
  const base64 = btoa(JSON.stringify(contextObj));
  return base64.replace(/\+/g, "-").replace(/=/g, "").replace(/\//g, "_");
};
const decodeContextString = function(contextString) {
  const replacedChars = contextString.replace(/-/g, "+").replace(/_/g, "/");
  const decoded = JSON.parse(atob(replacedChars));
  if (typeof decoded.expiresAt === "string") {
    decoded.expiresAt = new Date(decoded.expiresAt);
  }
  return decoded;
};
const getPersistedContext = () => {
  const contextString = getRawCookieValue();
  if (!contextString) {
    return null;
  }
  try {
    return decodeContextString(contextString);
  } catch (ex) {
    console.error("Error decoding context string", ex);
    return null;
  }
};

export { encodeContextObject, getPersistedContext, getRawCookieValue, resetCookieContext, setCookieContext };
//# sourceMappingURL=web-cookie.js.map
